import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import AdminAnalytics from "./AdminAnalytics";
import { Home, FileText, Newspaper, Inbox, ArrowRight } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ developments: 0, pages: 0, posts: 0, leads: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [d, p, b, l] = await Promise.all([
          api.get("/admin/developments"),
          api.get("/admin/pages"),
          api.get("/admin/blog"),
          api.get("/admin/leads"),
        ]);
        setStats({
          developments: d.data.length,
          pages: p.data.length,
          posts: b.data.length,
          leads: l.data.length,
        });
      } catch (_err) { /* ignore */ }
    })();
  }, []);

  const cards = [
    { label: "Developments", count: stats.developments, to: "/admin/developments", icon: Home, testId: "card-developments" },
    { label: "Site Pages", count: stats.pages, to: "/admin/pages", icon: FileText, testId: "card-pages" },
    { label: "Blog Posts", count: stats.posts, to: "/admin/blog", icon: Newspaper, testId: "card-blog" },
    { label: "Leads", count: stats.leads, to: "/admin/leads", icon: Inbox, testId: "card-leads" },
  ];

  return (
    <div className="p-10 lg:p-16" data-testid="admin-dashboard">
      <p className="text-[10px] tracking-[0.3em] uppercase text-[#73706B] mb-4">
        — Webmaster Dashboard
      </p>
      <h1
        className="text-5xl lg:text-6xl font-light mb-12"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        Welcome back.
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map((c) => (
          <Link
            key={c.label}
            to={c.to}
            data-testid={c.testId}
            className="group border border-[#E5DFD5] bg-[#FFFFFF] p-8 hover:border-[#1A1A1A] transition-colors"
          >
            <div className="flex items-start justify-between mb-6">
              <c.icon className="w-5 h-5 text-[#C5A880]" strokeWidth={1.5} />
              <ArrowRight className="w-4 h-4 text-[#73706B] group-hover:translate-x-1 group-hover:text-[#1A1A1A] transition-all" strokeWidth={1.5} />
            </div>
            <p
              className="text-5xl font-light text-[#1A1A1A] mb-2"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {c.count}
            </p>
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#73706B]">
              {c.label}
            </p>
          </Link>
        ))}
      </div>

      <AdminAnalytics />

      <div className="mt-16 border border-[#E5DFD5] bg-[#FFFFFF] p-10">
        <h2
          className="text-3xl font-light mb-4"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Quick actions
        </h2>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/admin/developments/new"
            data-testid="quick-new-dev"
            className="bg-[#1A1A1A] text-[#F9F6F0] px-6 py-3 text-[10px] tracking-[0.25em] uppercase hover:bg-[#C5A880] transition-colors"
          >
            + New Development
          </Link>
          <Link
            to="/admin/blog/new"
            data-testid="quick-new-post"
            className="border border-[#1A1A1A] text-[#1A1A1A] px-6 py-3 text-[10px] tracking-[0.25em] uppercase hover:bg-[#1A1A1A] hover:text-[#F9F6F0] transition-colors"
          >
            + New Blog Post
          </Link>
          <Link
            to="/admin/pages"
            data-testid="quick-edit-pages"
            className="border border-[#1A1A1A] text-[#1A1A1A] px-6 py-3 text-[10px] tracking-[0.25em] uppercase hover:bg-[#1A1A1A] hover:text-[#F9F6F0] transition-colors"
          >
            Edit Site Pages
          </Link>
        </div>
      </div>
    </div>
  );
}
